import { type Storefront } from 'niara-spear-crudmodel'
import type { HotelDetails } from '../types/hotels'
type Widgets = Storefront['widgets_homepage']

const R2_CDN_URL = process.env.R2_HOTEL_DETAILS_CDN_URL
const R2_CDN_BASE_URL = R2_CDN_URL?.endsWith('/') ? R2_CDN_URL : R2_CDN_URL + '/'

// Precisa garantir que todos esses hoteis já estejam na R2
const R2_HOTEL_IDS = [
  'HOTEL_OMNI_10027', // Hotel Demo - Bee2bee
  'HOTEL_OMNI_10081', // Hotel Niara
  'HOTEL_OMNI_3090', // Enotel Porto de Galinhas - All Inclusive
  'HOTEL_OMNI_3958', // Pratagy Beach Resort All Inclusive
  'HOTEL_OMNI_2879', // Hotel Fazenda Vale da Mantiqueira
  'HOTEL_OMNI_3532', // Fazzenda Park Resort
  'HOTEL_OMNI_21278', // Pyreneus Residence  GAV Resorts
  'HOTEL_OMNI_19569', // Porto Alto Resort  GAV Resorts
  'HOTEL_OMNI_9164', // Mavsa Resort
  'HOTEL_OMNI_19116', // Morro dos Anjos Águas Quentes Hotel Resort
  'HOTEL_OMNI_10771', // Hotel Fazenda China Park
  'HOTEL_OMNI_2405', // Hotel Alpestre
  'HOTEL_OMNI_5252', // Búzios Beach Resort by WAM Experience
  'HOTEL_OMNI_9694', // Salinas Maceió All Inclusive Resort
  'HOTEL_OMNI_9098', // Salinas Maragogi All Inclusive Resort
  'HOTEL_OMNI_8259', // Japaratinga Lounge Resort
]

// SE O HOTEL É DA R2, ENTÃO RETORNA A URL DA R2, CASO CONTRÁRIO, RETORNA A URL DO CDN PADRÃO DA OMNIBEES
export const convertHotelDetailsToR2 = (hotelDetails: HotelDetails): HotelDetails => {
  if (!hotelDetails) return hotelDetails

  const hotelId = hotelDetails?.hotelId

  if (!R2_HOTEL_IDS.includes(hotelId)) {
    return hotelDetails
  }
  return {
    ...hotelDetails,
    images: hotelDetails?.images.map((image) => {
      const fileName = image?.split('/')?.[image?.split('/')?.length - 1]
      return R2_CDN_BASE_URL + `${hotelId}/images/${fileName}`
    }),
    guestRooms: hotelDetails.guestRooms.map((room) => {
      return {
        ...room,
        medias: room.medias.map((media) => {
          return {
            ...media,
            images: media.images.map((image) => {
              const fileName = image?.url?.split('/')?.[image?.url?.split('/')?.length - 1]
              return {
                ...image,
                url: R2_CDN_BASE_URL + `${hotelId}/rooms/${room?.id}/${fileName}`,
              }
            }),
          }
        }),
      }
    }),
  }
}

// SE O LOCATOR É DA R2, ENTÃO RETORNA A URL DA R2 PARA OS WIDGETS, CASO CONTRÁRIO, RETORNA A URL DO CDN PADRÃO DA OMNIBEES
export const convertWidgetsToR2 = (locator: string, widgets: Widgets): Widgets => {
  return widgets?.map((widget) => ({
    ...widget,
    content: widget.content?.map((item) => {
      if (!item?.hotelId) return item

      return {
        ...item,
        image:
          item?.image && item?.image?.startsWith('https://media.omnibees.com')
            ? (() => {
                const extract = extractHotelAndImageFromMediaOmnibees(item?.image)
                return extract ? R2_CDN_BASE_URL + `${extract?.hotelId}/images/${extract?.fileName}` : item?.image
              })()
            : item?.image,
        images: item?.images?.map((image) => {
          if (image && image.startsWith('https://media.omnibees.com')) {
            const extract = extractHotelAndImageFromMediaOmnibees(image)
            return extract ? R2_CDN_BASE_URL + `HOTEL_OMNI_${extract.hotelId}/images/${extract.fileName}` : image
          }
          return image
        }),
      }
    }),
  }))
}

// FUNÇÃO AUXILIAR PARA EXTRAIR O HOTEL ID E FILENAME DA IMAGEM DA URL DA OMNIBEES
// VALIDA TAMBÉM SE ESTÁ NA WHITELIST
const extractHotelAndImageFromMediaOmnibees = (url: string) => {
  // const url = "https://media.omnibees.com/Images/9164/Property/1294428.jpg";

  const regex = /Images\/(\d+)\/Property\/([^/]+\.\w+)$/

  const match = url.match(regex)

  if (match) {
    const hotelId = `HOTEL_OMNI_${match[1]}` // "HOTEL_OMNI_9164"
    const fileName = match[2] // "1294428.jpg"

    if (!R2_HOTEL_IDS.includes(hotelId)) {
      return null
    }

    return { hotelId, fileName }
  }
  return null
}
